module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAChMUFRgZTl1gY2Z1q66vtLW2ub2+w8TX2N/g4ejr7PbiIC67AAAAnElEQVRIx+2V3Q6CMAyFC8hAGQIiiALCef+X5HbDsFqNITE7d136bf1Jzoi83tcpH7GpqchW6XEJRqWygCuGY7z9fJQOaMwDjXvkrjjsoI2wRsL1mKA2ohkBBwSYjQjgx2jlfAy0LdHrRF3ATQj8vod/APwe/B6+BcQ2IzYyjS4UWSU16NODy4wfthmTqji7v6jVJdn5KflQvPbWAhVnLwGpc08KAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/course/zhishidian@2x.png
// module id = WFc3
// module chunks = 0